// import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Pricing from './components/Pricing';
import Docs from './components/Docs';
import Policy from './components/Policy';
import PrivacyPolicy from './components/PrivacyPolicy';
import BlogPage from './pages/blog';
import BlogDetailPage from './pages/blog/BlogDetailPage';
import ScrollToTop from './components/ScrollToTop';
// import { CDN_URLS } from './config/cdn';
import TopBanner from './components/TopBanner';
import { ENABLE_TOP_BANNER } from './config/env';
import RouteChangeTracker from './components/RouteChangeTracker';

function App() {
  // useEffect(() => {
  //   // Set global cursor style
  //   const setCursor = () => {
  //     document.body.style.cursor = `url("${CDN_URLS.cursor}"), auto`;
  //     document.documentElement.style.cursor = `url("${CDN_URLS.cursor}"), auto`;

  //     // Apply cursor to all elements
  //     const style = document.createElement('style');
  //     style.textContent = `
  //       *, *::before, *::after {
  //         cursor: url("${CDN_URLS.cursor}"), auto !important;
  //       }
  //     `;
  //     document.head.appendChild(style);
  //   };

  //   setCursor();
  // }, []);
  return (
    <Router>
      <RouteChangeTracker />
      <ScrollToTop />
      <Routes>
        {/* Docs route - full screen without header/footer */}
        <Route path="/docs" element={<Docs />} />

        {/* Other routes with header/footer */}
        <Route path="/*" element={
          <div className={`container ${ENABLE_TOP_BANNER ? 'with-top-banner' : ''}`}>
            {ENABLE_TOP_BANNER && <TopBanner />}
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/policy" element={<Policy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:name" element={<BlogDetailPage />} />
            </Routes>
            <Footer />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;